/** @jsxImportSource @emotion/react */

import React from "react";
import { fromPublic } from "../../utils";
import styled from "@emotion/styled";
import ImageLottie from "./ImageLottie";

const StyledOnboardingStep = styled.div`
  background-color: #eff2f5;
  overflow-x: hidden;
  text-align: center;
  position: relative;
`;

const ImageContainer = styled.div`
  img {
    width: 100%;
    height: 100%;
  }
`;

interface OnboardingStepProps {
  image: string;
  imageLottie?: string;
  children: React.ReactNode;
  lottieAsOverlay?: boolean;
}

const OnboardingStep: React.FC<OnboardingStepProps> = ({ 
  image, 
  imageLottie, 
  children,
  lottieAsOverlay = true 
}) => {
  return (
    <StyledOnboardingStep>
      {(image || (imageLottie && !lottieAsOverlay)) && (
        <ImageContainer>
          {imageLottie && !lottieAsOverlay ? (
            <ImageLottie imageLottie={imageLottie} />
          ) : (
            image && <img alt="" src={fromPublic(image)} />
          )}
        </ImageContainer>
      )}
      
      {imageLottie && lottieAsOverlay && (
        <ImageLottie imageLottie={imageLottie} fullScreen={true} />
      )}
      
      {children}
    </StyledOnboardingStep>
  );
};

export default OnboardingStep;